import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Supprimer l'erreur ResizeObserver du webpack-dev-server (inoffensive)
const resizeObserverErr = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends resizeObserverErr {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

import ElementPlus from 'element-plus'
import { ElNotification } from 'element-plus'
import 'element-plus/dist/index.css'
import frLocale from 'element-plus/es/locale/lang/fr'

// Service de gestion d'erreurs
import { initGlobalErrorHandlers } from '@/utils/errorHandler'   

import mdi from './plugins/mdi.js'
import chartkick from './plugins/data_graph.js'

import * as echarts from 'echarts'
import { BaklavaVuePlugin } from '@baklavajs/plugin-renderer-vue3'
import '@baklavajs/plugin-renderer-vue3/dist/styles.css'

import '@/permission'   
import '@/icons/mdi'
import '@/icons/luce'               // icône maison de Luce (registre Iconify)
//import registerIcons from '@/icons'  
//import '@/icons'
//import SvgIcon from '@/components/SvgIcon/index.vue'

import 'leaflet/dist/leaflet.css'
import './assets/sass/style.scss'

import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.locale('fr')
// « il y a 12 minutes » : lecture du centre de notifications.
dayjs.extend(relativeTime)

export function date2dayjs(date, format = 'DD/MM/YYYY', fallback = null) {
  return dayjs(date).isValid()
    ? dayjs(date).format(format)
    : (fallback ?? 'n/c')
}

// composants globaux
import BackButtonComponent from '@/components/BackButton/BackButtonComponent'
import MarginFooterComponent from '@/components/MarginFooter/MarginFooterComponent'

// utils
import { formator } from '@/utils/formator.js'
import { checkRoles, isExtranetUser } from '@/utils/checkRoles.js'
import { checkPerms } from '@/utils/checkPerms.js'

// helpers (filtres)
import * as filters from './filters'

const app = createApp(App)

// composants globaux
app.component('BackButton', BackButtonComponent)
app.component('MarginFooter', MarginFooterComponent)
//app.component('svg-icon', SvgIcon)

// icônes
//registerIcons(app)

// propriétés globales
app.config.globalProperties.$formator   = formator
app.config.globalProperties.$checkRoles = checkRoles
app.config.globalProperties.$isExtranet = isExtranetUser
app.config.globalProperties.$checkPerms = checkPerms
app.config.globalProperties.$node_env   = process.env.NODE_ENV
app.config.globalProperties.$date       = date2dayjs
app.config.globalProperties.$echarts    = echarts
app.config.globalProperties.$filters    = filters
app.config.globalProperties.$notification = ElNotification

// plugins
app.use(store)               // store avant router (guards)
app.use(router)
app.use(ElementPlus, { locale: frLocale })
app.use(mdi)
app.use(chartkick)
app.use(BaklavaVuePlugin)

// Initialiser les handlers globaux d'erreurs
initGlobalErrorHandlers(app)

app.mount('#app')

window.store = store